export enum MoreMenuSubmenu {
  SETTINGS,
  TOGGLE_COLUMNS,
}
